import React from 'react';
import PropTypes from 'prop-types';

const Bold = props => <span className="fontWeight-6">{props.children}</span>;

Bold.propTypes = {
  children: PropTypes.node,
};

export default Bold;



// WEBPACK FOOTER //
// ./src/configs/pages/ebook-design-systems/bold.js